import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as loginActions from '../../store/modules/loginSlice';
import { bindActionCreators } from 'redux';
import OTPVerificationPanel from './OTPVerificationPanel';
import { showToast } from '../Common/Messages';

const FindIdPasswordPanel = (props) => {
    const dispatch = useDispatch();
    const LoginActions = bindActionCreators(loginActions, dispatch);
    const [userInfo, setUserInfo] = useState({
        userName: '',
        userId: '',
        noticed: '0',
        btnState: '임시 비밀번호 받기',
        isVerify: false,
        authCode: '0'
    });

    const handleChange = (e) => {
        setUserInfo(prev => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        });
    };

    const AfterCheckAuth = (authCode) => {
        setUserInfo(prev => {
            return {
                ...prev,
                isVerify: true,
                authCode: authCode
            }
        });
    };

    const AfterRequestAuth = () => {
        setUserInfo(prev => {
            return {
                ...prev,
                isDisabled: 'disable'
            }
        });
    };

    const CheckNameId = (e) => {
        e.preventDefault();

        const userNameId = {
            userName: userInfo.userName,
            userId: encodeURI(userInfo.userId),
            authCode: encodeURI(userInfo.authCode)
        };

        if (userNameId.userName === '' || userNameId.userId === '') {
            showToast('warning', '입력하지 않은 정보가 있습니다.');
        }
        else {
            setUserInfo(prev => { return { ...prev, btnState: '발송 중...' } });
            fetch('api/Login/FindPassword', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userNameId)
            }).then(async (response) => response.json())
                .then(async (responseData) => {
                    if (responseData.status === "Success Finding") {
                        setUserInfo(prev => { return { ...prev, noticed: '0' } });
                        const result = {
                            userId: userNameId.userId,
                            message: responseData.message,
                            result: responseData.status
                        };
                        await LoginActions.setResultLogin(result);
                        props.setPanelType('showMessage');
                    }
                    else if (responseData.status === "Fail Sending") {
                        showToast('danger', responseData.message);
                    }
                    else if (responseData.status === "Fail Finding") {
                        showToast('warning', responseData.message);
                    }
                    setUserInfo(prev => { return { ...prev, btnState: '임시 비밀번호 발송' } });
                });
        }
    };

    return (
        <div className="login-wrap">
            <form className="login-box pw-find">
                <h2 className='login-title'>비밀번호 재설정</h2>
                {!userInfo.isVerify ? <p className="pw-change-txt">먼저, 본인확인을 위해 이메일 인증을 해주세요.</p> : null}
                <div className="input-ui">
                    <input
                        name='userName'
                        value={userInfo.userName}
                        onChange={e => handleChange(e)}
                        placeholder='이름'
                        onFocus={(e) => e.target.placeholder = '이름'}
                        disabled={userInfo.isDisabled}
                    />
                </div>
                <div className="input-ui">
                    <input
                        name='userId'
                        value={userInfo.userId}
                        onChange={e => handleChange(e)}
                        placeholder='이메일'
                        onFocus={(e) => e.target.placeholder = '아이디'}
                        disabled={userInfo.isDisabled}
                    />
                </div>
                <OTPVerificationPanel buttonTitle={'인증번호 요청'} state={userInfo} fnAfterCheckAuth={AfterCheckAuth} fnAfterRequestAuth={AfterRequestAuth} />
                {userInfo.isVerify ?
                    <div className="btn-wrap">
                        <button onClick={(e) => CheckNameId(e)} className='btn-auth'>{userInfo.btnState}</button>
                    </div>
                    : null}
            </form>
        </div>
    );
}

export default FindIdPasswordPanel;